import { useSiteStore } from "../stores/siteStore";

/** Returns the active site ID for the current user. Replaces all VITE_SITE_ID references. */
export function useSiteId(): string {
  return useSiteStore((s) => s.activeSiteId);
}
